import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { appConfig } from '../../settings';
import { IPackageInfo, IPackageSoldInfo, ISelectList } from '../../interfaces';

export function usePackageInfo(): IPackageInfo {
    return useContext(MobXProviderContext).RootStore.packageStore.packageInfo;
}

export function usePackageSoldInfo(): IPackageSoldInfo {
    return useContext(MobXProviderContext).RootStore.packageStore.packageSoldInfo;
}

export function usePackagePaymentTypes(): ISelectList {
    const paymentSelect = Object.values(appConfig.paymentMethods);

    return paymentSelect.map((value: string) => {
        return {
            id: value,
            name: value.split('_').join(' '),
            value: value,
        };
    });
}
